import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface ReasonSummary {
  id: string;
  name?: string;
  key?: string;
  label?: string;
  kind?: string;
  displayOrder: number;
}

export interface GetClaimReasonsQueryArgs {
  claimId: string;
}

export const getClaimReasonsRequest = ({
  claimId,
}: GetClaimReasonsQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/reasons`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimReasonsQuery = async (
  args: GetClaimReasonsQueryArgs,
): Promise<BackResponse<ReasonSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ReasonSummary[]>>(
      getClaimReasonsRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
